import { createFileRoute } from '@tanstack/react-router'
import { AdminReviewsPage } from '@/features/reviews/pages/admin-reviews-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const reviewsSearchSchema = createTableSearchSchema({
  defaultPageSize: 25,
  sortIds: ['submitted_at', 'song_title', 'status'],
  filterKeys: ['queue', 'submitter'],
})

export const Route = createFileRoute('/reviews')({
  staticData: { title: 'Reviews' },
  validateSearch: reviewsSearchSchema,
  component: AdminReviewsPage,
})
